import { render, staticRenderFns } from "./GainsReportPage.vue?vue&type=template&id=539d12f2&"
import script from "./GainsReportPage.vue?vue&type=script&lang=ts&"
export * from "./GainsReportPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/src/services/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('539d12f2')) {
      api.createRecord('539d12f2', component.options)
    } else {
      api.reload('539d12f2', component.options)
    }
    module.hot.accept("./GainsReportPage.vue?vue&type=template&id=539d12f2&", function () {
      api.rerender('539d12f2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/340th/Reports/GainsReportPage.vue"
export default component.exports